import type { MutableRefObject } from 'react';

import { PsyToolsId } from '../../../../components/meet/tools-panel/types';
import { setActiveTool } from '../../../../store/meetActiveTool.slice';
import {
  clearEmotionsClientSelections,
  clearEmotionsSharedView,
  setEmotionsClientSelection,
  setEmotionsSharedView,
} from '../../../../store/emotionsGroup.slice';
import type { MeetOverlaysBridgeApi } from '../../MeetOverlaysProvider';

export interface EmotionsSelectionPayload {
  category: string[];
  emo: string[];
}

export interface EmotionsRoomHandlersArgs {
  isPsychologist: boolean;
  isGroupConsultationFlag: boolean;
  dispatch: (action: unknown) => void;
  overlaysApiRef: MutableRefObject<MeetOverlaysBridgeApi | null>;
  onEmotionsOpen?: () => void;
  onEmotionsClose?: () => void;
  onClientEmotionsSelection?: (payload: { from: string; selection: EmotionsSelectionPayload }) => void;
}

export interface EmotionsRoomHandlers {
  onEmotionsOpen?: () => void;
  onClientEmotionsSelection?: (from: string, selection: EmotionsSelectionPayload) => void;
  onEmotionsClose?: () => void;
  onEmotionsSharedView?: (label: string, emo: string[]) => void;
}

export function createEmotionsRoomHandlers({
  isPsychologist,
  isGroupConsultationFlag,
  dispatch,
  overlaysApiRef,
  onEmotionsOpen,
  onEmotionsClose,
  onClientEmotionsSelection,
}: EmotionsRoomHandlersArgs): EmotionsRoomHandlers {
  return {
    onEmotionsOpen:
      !isPsychologist
        ? () => {
            if (isGroupConsultationFlag) {
              overlaysApiRef.current?.setShowModalInstruct(
                window.innerHeight > window.innerWidth
                  ? 'Психолог активировал инструмент "Детектор эмоций". Пожалуйста, НЕ переворачивайте экран телефона в горизонтальное положение'
                  : 'Психолог включил инструмент «Детектор эмоций».',
              );
            }
            dispatch(setActiveTool(PsyToolsId.EMOTIONS));
            onEmotionsOpen?.();
          }
        : undefined,

    onClientEmotionsSelection:
      isPsychologist
        ? (from: string, selection: EmotionsSelectionPayload) => {
            if (isGroupConsultationFlag) {
              dispatch(setEmotionsClientSelection({ participantIdentity: from, ...selection }));
            }
            onClientEmotionsSelection?.({ from, selection });
          }
        : undefined,

    onEmotionsClose:
      !isPsychologist
        ? () => {
            dispatch(setActiveTool(0));
            if (isGroupConsultationFlag) {
              dispatch(clearEmotionsClientSelections());
              dispatch(clearEmotionsSharedView());
            }
            onEmotionsClose?.();
          }
        : undefined,

    onEmotionsSharedView:
      !isPsychologist && isGroupConsultationFlag
        ? (label: string, emo: string[]) => {
            dispatch(setEmotionsSharedView({ participantLabel: label, emo }));
          }
        : undefined,
  };
}

